const store = {
    namespaced: true,
    state() {
        return {
            reviews: []
        }
    },
    getters: {
        getReviews(state) {
            return state.reviews
        }
    },
    mutations: {
        setReviews(state, reviews) {
            state.reviews = reviews
        },
        setMainReview(state, review) {
            let newReviews = state.reviews.filter(e => e !== review)
            newReviews.unshift(review)
            state.reviews = newReviews
        }
    },
}

export default store